type Props = {
  icon: any;
  title: string;
  value: string;
};

const HeaderBox = ({ icon, title, value }: Props) => {
  return (
    <div className="bg-white px-4 py-6 flex items-center justify-center gap-[18px] w-full rounded-lg">
      <div className="bg-[#EEF0FF] p-4 rounded-full w-[57px] h-[57px] flex items-center justify-center">
        {icon}
      </div>
      <div className="flex flex-col items-center justify-start w-full h-full">
        <span className="text-[#A3AED0] text-sm font-normal w-full">
          {title}
        </span>
        <span className="text-color-primary text-2xl font-semibold w-full">
          {value}
        </span>
      </div>
    </div>
  );
};

export default HeaderBox;
